import { render, staticRenderFns } from "./add-vac-svg.vue?vue&type=template&id=47714cc8&scoped=true"
import script from "./add-vac-svg.vue?vue&type=script&lang=js"
export * from "./add-vac-svg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47714cc8",
  null
  
)

export default component.exports